/**
 * When true, the product is fully free (SEO / growth mode):
 * no pricing page, no credit counter, no watermark, direct download.
 * Set GATSBY_FREE_MODE=false at build time to restore paid flows.
 */
export function isFreeMode(): boolean {
  return process.env.GATSBY_FREE_MODE !== "false"
}

export function isPricingPath(href: string): boolean {
  if (!href) return false
  const normalized = href.replace(/^https?:\/\/[^/]+/, "").split("?")[0].split("#")[0]
  return /\/pricing\/?$/.test(normalized)
}

/** Hide pricing CTAs and account credit UI when free mode is on. */
export function showMonetization(): boolean {
  return !isFreeMode()
}

const FREE_HERO_DESCRIPTION_PREFIX = "PhotoSharpener is completely FREE to use. "

/** Prepends the free-mode hero line when the standard homepage description is used. */
export function applyFreeModeHeroDescription(description: string): string {
  if (!isFreeMode() || !description?.trim()) return description
  if (description.includes("PhotoSharpener is completely FREE")) return description
  if (description.startsWith("Recover lost detail")) {
    return `${FREE_HERO_DESCRIPTION_PREFIX}${description}`
  }
  return description
}

/** Rewrites hero CTAs like "… — it's free to try" to "… — It's free" in free mode. */
export function applyFreeModePrimaryCta(label: string): string {
  if (!isFreeMode() || !label?.trim()) return label
  return label
    .trim()
    .replace(/\s*[-–—]\s*it'?s free to try\s*$/i, " — It's free")
    .replace(/\s*[-–—]\s*free to try\s*$/i, " — It's free")
}
